"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buyBoxNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const extractProductChannels = (children) => {
    var _a;
    let result = {};
    const constantCanalesPropios = "Lo mejor de Movistar Plus+";
    const canalesPropiosImagesChannels = [];
    if (Object.keys(children).length === 0) {
        return null;
    }
    for (const key in children) {
        if (children.hasOwnProperty(key)) {
            const { categories, data, name } = children[key];
            const icono = ((_a = data.fields) === null || _a === void 0 ? void 0 : _a.icono) || null;
            categories.forEach((item) => {
                if (item.toLowerCase() === constantCanalesPropios.toLowerCase()) {
                    canalesPropiosImagesChannels.push({
                        src: icono,
                        width: 143,
                        height: 99,
                        channelName: name,
                    });
                }
                else {
                    if (!result[item]) {
                        if (item === "TV ··· PAQUETE TV ··· MAS DE 80 CANALES") {
                            item = "+ 80 CANALES";
                        }
                        const capitalizeCategorie = item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
                        result[item] = {
                            categorie: capitalizeCategorie,
                            imagesChannel: [],
                        };
                    }
                    result[item].imagesChannel.push({
                        src: icono,
                        width: 143,
                        height: 99,
                        channelName: name,
                    });
                }
            });
        }
    }
    if (canalesPropiosImagesChannels.length > 0) {
        result = Object.assign({ [constantCanalesPropios]: {
                categorie: constantCanalesPropios,
                imagesChannel: canalesPropiosImagesChannels,
            } }, result);
    }
    return result;
};
const extractProductOffer = (offer) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const res = {};
    const { data: offerData } = offer;
    res.price = offer.price || null;
    res.promoId = offer.promoId || null;
    res.bandaPromo = ((_a = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _a === void 0 ? void 0 : _a.bandaPromo) || null;
    res.bandaInfo = ((_b = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _b === void 0 ? void 0 : _b.bandaInfo) || null;
    res.claimPromo = ((_c = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _c === void 0 ? void 0 : _c.claimPromo) || null;
    res.preTextLegal = ((_d = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _d === void 0 ? void 0 : _d.preLegalcorto) || null;
    res.titleLegal = ((_e = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _e === void 0 ? void 0 : _e.titleLegalcorto) || null;
    res.legal = ((_f = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _f === void 0 ? void 0 : _f.legalCorto) || null;
    res.labelText = ((_g = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _g === void 0 ? void 0 : _g.labelText) || null;
    res.textPrice = ((_h = offerData === null || offerData === void 0 ? void 0 : offerData.fields) === null || _h === void 0 ? void 0 : _h.unidad) || null;
    return res;
};
const extractProductInfo = (product) => {
    var _a;
    if (!product || Object.keys(product).length == 0) {
        return null;
    }
    const res = {
        name: product.name,
        alias: product.alias,
        baseOffer: {},
        offer: {},
        channels: {},
    };
    const { data, baseOffer, offers, children } = product;
    if (baseOffer) {
        res.baseOffer = extractProductOffer(baseOffer);
    }
    if (children) {
        res.channels = extractProductChannels(children);
    }
    if (data) {
        const { fields } = data;
        let productoGPBAF = null;
        productoGPBAF =
            (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_PRODUCTO_GP_BAF"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["BUSINESS_ZONA_NAME_BAF"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_TV"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_PRODUCTO"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_SEGUROS"]) ||
                (fields === null || fields === void 0 ? void 0 : fields["DATAMAP_PRODUCTO_GP_SIMPLE"]);
        if (fields === null || fields === void 0 ? void 0 : fields["COMPOSICION_BUNDLE"]) {
            const { fields: fieldsConectividad } = (_a = fields === null || fields === void 0 ? void 0 : fields["COMPOSICION_BUNDLE"].fields) === null || _a === void 0 ? void 0 : _a.conectividad.data;
            productoGPBAF = fieldsConectividad === null || fieldsConectividad === void 0 ? void 0 : fieldsConectividad["DATAMAP_PRODUCTO_GP_BAF"];
        }
        if (productoGPBAF) {
            const { fields } = productoGPBAF;
            res.currency = fields === null || fields === void 0 ? void 0 : fields.unidad;
            res.target = fields === null || fields === void 0 ? void 0 : fields.target;
            res.urlProdCompra = fields === null || fields === void 0 ? void 0 : fields.urlProdCompra;
            res.url2ProdCompra = (fields === null || fields === void 0 ? void 0 : fields.url2ProdCompra) || null;
        }
    }
    if (offers && Object.keys(offers).length > 0) {
        Object.keys(offers).map((offer) => {
            const oferta = offers[offer];
            const ofertaRes = extractProductOffer(oferta);
            res.offer = ofertaRes;
        });
    }
    return res;
};
const extraModalInfo = (modalContent) => {
    if (!modalContent || Object.keys(modalContent).length == 0) {
        return null;
    }
    let res = null;
    const { fields } = modalContent === null || modalContent === void 0 ? void 0 : modalContent.data;
    if (fields) {
        res = {
            "Text-1": Object.assign(Object.assign({}, mocks_json_1.default["Modal"]["Text-1"]), { text: fields === null || fields === void 0 ? void 0 : fields.title }),
            "Text-2": Object.assign(Object.assign({}, mocks_json_1.default["Modal"]["Text-2"]), { text: fields === null || fields === void 0 ? void 0 : fields.description }),
            "Button-1": Object.assign(Object.assign({}, mocks_json_1.default["Modal"]["Button-1"]), { href: fields === null || fields === void 0 ? void 0 : fields.urlProductAlternative, label: fields === null || fields === void 0 ? void 0 : fields.button })
        };
    }
    return res;
};
const normalizeOrionStructure = (product, buttonCompraLabel, buttonCompraType, topDescription, upDescription, urlLinkclient, urlLinknoclient, urlProdAncla, preLegalsText, onclickBinding, displayChannels) => {
    var _a, _b;
    let res = null;
    if (product && ((_a = Object.keys(product)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        res = {};
        let offerInfo = product.baseOffer;
        let channelsInfo = product.channels;
        let button = Object.assign(Object.assign({}, buttonCompraLabel), { target: product.target || "_self", href: product.url2ProdCompra || product.urlProdCompra || "" });
        if (button && ((_b = button.href) === null || _b === void 0 ? void 0 : _b.trim().length) === 0) {
            let finalUrlLinknoclient = urlLinknoclient;
            let finalUrlLinkclient = urlLinkclient;
            if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
                finalUrlLinknoclient =
                    urlLinknoclient && urlLinknoclient.indexOf("?") !== -1
                        ? `${urlLinknoclient}&utm_source=novum`
                        : `${urlLinknoclient}?utm_source=novum`;
                finalUrlLinkclient =
                    urlLinkclient && urlLinkclient.indexOf("?") !== -1
                        ? `${urlLinkclient}&utm_source=novum`
                        : `${urlLinkclient}?utm_source=novum`;
            }
            button = Object.assign(Object.assign({}, buttonCompraLabel), { target: product.target || "_self", href: product.url2ProdCompra || product.urlProdCompra || "", urlLinkclient: finalUrlLinkclient, urlLinknoclient: finalUrlLinknoclient });
        }
        // el €/mes separado
        let currency = "";
        let quote = "";
        if (product.currency) {
            const currencySplit = product.currency.split("/");
            currency = currencySplit[0];
            quote = currencySplit[1] || "";
        }
        let price1 = { currency };
        let price2 = { price: offerInfo.price, currency, quote };
        // miro si me quedo con los datos de oferta o baseoffer
        if (product.offer && Object.keys(product.offer).length > 0) {
            price1.price = offerInfo.price;
            offerInfo = product.offer;
            price2 = Object.assign(Object.assign({}, price2), { price: offerInfo.price, color: "red_dark" });
        }
        if (upDescription.text) {
            res["Text-0"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-0"]), upDescription);
        }
        if (offerInfo.bandaPromo) {
            res["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { label: offerInfo.bandaPromo });
        }
        else if (product.baseOffer.labelText) {
            res["Label-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Label-1"]), { label: product.baseOffer.labelText, theme: "gift" });
        }
        if (price1 && price1.price) {
            res["Price-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-1"]), price1);
        }
        if (offerInfo && offerInfo.textPrice) {
            res["Price-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Price-2"]), { currency: offerInfo.textPrice });
        }
        if (price2 && price2.price) {
            const isSamePrice = price1 && price1.price && price1.price === price2.price;
            res["Price-2"] = Object.assign(Object.assign(Object.assign({}, mocks_json_1.default["Price-2"]), price2), { color: !isSamePrice && price2.color ? price2.color : mocks_json_1.default["Price-2"].color });
        }
        if (offerInfo.bandaInfo) {
            res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: offerInfo.bandaInfo });
        }
        if (topDescription) {
            res["Text-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), topDescription);
        }
        if (button && (button.href || button.urlLinkclient || button.urlLinknoclient)) {
            let finalhref = button.href;
            if (process.env.NEXT_PUBLIC_WEB_VIEW === "true") {
                finalhref =
                    button.href.trim().length > 0
                        ? button.href.indexOf("?") !== -1
                            ? `${button.href}&utm_source=novum`
                            : `${button.href}?utm_source=novum`
                        : "";
            }
            res["Button-1"] = Object.assign(Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), button), { href: finalhref });
        }
        if (onclickBinding) {
            res["Button-1"] = Object.assign(Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), button), { onclickBinding: onclickBinding });
        }
        if (res["Button-1"] && res["Button-1"].type && buttonCompraType) {
            res["Button-1"].type = buttonCompraType;
        }
        if (urlProdAncla) {
            res["Button-1"].href = urlProdAncla;
        }
        if (offerInfo.preTextLegal) {
            res["Text-3"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-3"]), { text: offerInfo.preTextLegal });
        }
        if (preLegalsText) {
            res["Text-4"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-4"]), { text: preLegalsText });
        }
        if (offerInfo.titleLegal && offerInfo.legal) {
            res["Button-2"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-2"]), { label: offerInfo.titleLegal });
        }
        if (offerInfo.titleLegal && offerInfo.legal) {
            res["Legal-1"] = {
                "Text-1": Object.assign(Object.assign({}, mocks_json_1.default["Legal-1"]["Text-1"]), { text: offerInfo.titleLegal }),
                "Text-2": Object.assign(Object.assign({}, mocks_json_1.default["Legal-1"]["Text-2"]), { text: offerInfo.legal }),
            };
        }
        if (channelsInfo && displayChannels) {
            res["Channels-1"] = { channelsInfo };
        }
    }
    return res;
};
/**
 * normalizador del modulo MODULO_BUYBOX
 * @param {object} fields
 * @returns
 */
const buyBoxNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    try {
        let res = {};
        const buttonCompraLabel = { label: (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.textButton };
        const buttonCompraType = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.typeButton;
        const preLegalsText = (_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.textInfo;
        const topDescription = { text: (_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.topDescription };
        const upDescription = { text: (_e = data === null || data === void 0 ? void 0 : data.fields) === null || _e === void 0 ? void 0 : _e.upDescription };
        const urlLinkclient = (_f = data === null || data === void 0 ? void 0 : data.fields) === null || _f === void 0 ? void 0 : _f.urlLinkclient;
        const urlLinknoclient = (_g = data === null || data === void 0 ? void 0 : data.fields) === null || _g === void 0 ? void 0 : _g.urlLinknoclient;
        const urlProdAncla = (_h = data === null || data === void 0 ? void 0 : data.fields) === null || _h === void 0 ? void 0 : _h.urlProdAncla;
        const products = (_j = data === null || data === void 0 ? void 0 : data.fields) === null || _j === void 0 ? void 0 : _j.products;
        let product = null;
        const productZL = extractProductInfo((_k = data === null || data === void 0 ? void 0 : data.fields) === null || _k === void 0 ? void 0 : _k.productZL);
        const productZR = extractProductInfo((_l = data === null || data === void 0 ? void 0 : data.fields) === null || _l === void 0 ? void 0 : _l.productZR);
        const onclickBinding = (_m = data === null || data === void 0 ? void 0 : data.fields) === null || _m === void 0 ? void 0 : _m.onclickBinding;
        const displayChannels = /true/.test((_o = data === null || data === void 0 ? void 0 : data.fields) === null || _o === void 0 ? void 0 : _o.displayChannels);
        const modalContent = extraModalInfo((_p = data === null || data === void 0 ? void 0 : data.fields) === null || _p === void 0 ? void 0 : _p.modalContent);
        //Si viene un array de products, y este solo tiene 1, consideramos que tiene mas prioridad
        if (Array.isArray(products) && products.length === 1) {
            product = extractProductInfo(products[0]);
        }
        if (product) {
            res["Product-1"] = normalizeOrionStructure(product, buttonCompraLabel, buttonCompraType, topDescription, upDescription, urlLinkclient, urlLinknoclient, urlProdAncla, preLegalsText, onclickBinding, displayChannels);
        }
        else {
            res["Product-1"] = normalizeOrionStructure(productZL, buttonCompraLabel, buttonCompraType, topDescription, upDescription, urlLinkclient, urlLinknoclient, urlProdAncla, preLegalsText, onclickBinding, displayChannels);
            res["Product-2"] = normalizeOrionStructure(productZR, buttonCompraLabel, buttonCompraType, topDescription, upDescription, urlLinkclient, urlProdAncla, urlLinknoclient, preLegalsText, onclickBinding, displayChannels);
        }
        if (modalContent) {
            res.modalContentNoAvailable = modalContent;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.buyBoxNormalizer = buyBoxNormalizer;
exports.default = exports.buyBoxNormalizer;
//# sourceMappingURL=index.js.map